/**
 * Module dependencies
 */
const React = require('react');
const PropTypes = require('prop-types');
const injectI18n = require('nordic/i18n/injectI18n');
const DocsPage = require('../../components/Documentation');

const { useEffect } = React;

const View = (props) => {
  useEffect(() => {
    try {
      let anchorId = window?.location?.hash;
      if (anchorId && anchorId.contains('&')) {
        const anchorList = anchorId.split('&');
        const hasLocation = anchorList.find((anchor) => anchor.includes('dx.location'));
        anchorId = hasLocation ? hasLocation.split('=')[1] : anchorList[0].replace(/(#|=|&)/gm, '');
      }
      if (anchorId && document?.querySelector(anchorId)) {
        const offset = document?.querySelector(anchorId)?.offsetTop;
        const scrollY = offset - 65; // navbar
        window.scrollTo(0, scrollY);
      }
    } catch (e) {
      console.log('error scrolling to anchor', e);
    }
  }, []);

  return (
    <DocsPage {...props} />
  );
};

View.propTypes = {
  platform: PropTypes.shape({
    siteId: PropTypes.string.isRequired,
  }).isRequired,
  sentDate: PropTypes.string.isRequired,
  assetsPath: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
};

/**
 * Inject i18n context as props into View.
 */
module.exports = injectI18n(View);
